import { MediaPlanTab as MediaPlanTabContent } from "@features/mmm/components/media-plan/media-plan-tab";

export const MediaPlanTab = ({
  goBack,
  goBackText,
  autoOpenModal = false,
}: {
  goBack: () => void;
  goBackText: string;
  autoOpenModal?: boolean;
}) => {
  return (
    <MediaPlanTabContent
      goBack={goBack}
      goBackText={goBackText}
      autoOpenModal={autoOpenModal}
    />
  );
};
